import { render } from "./AdminDashboardV2.vue?vue&type=template&id=2badae12&ts=true"
import script from "./AdminDashboardV2.vue?vue&type=script&lang=ts"
export * from "./AdminDashboardV2.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__